import { Suspense, useEffect, useRef } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import Beach from './Beach';
import Mud from './Mud';
import Lights from './Lights';
import Models from './Models';
import Camera from './Camera';
import { Raycaster, Vector2 } from 'three';
import * as THREE from 'three';

const SceneContent = (props) => {
	const { setSceneIsLoaded, activeItemIndex, setActiveToolTip, information } = props;
	const camera = useRef();

	const hoveredItem = useRef(-1);

	const currentOffset = useRef(new Vector2(0, 0));
	const targetOffset = useRef(new Vector2(0, 0));

	useFrame(({ mouse, scene, }) => {

		if (!camera.current) return;

		const raycaster = new Raycaster();
		raycaster.setFromCamera(mouse, camera.current);

		if (activeItemIndex === -1) {
			const intersects = raycaster.intersectObjects(scene.children, true);
			let modelIntersect = null;
			let mudIntersect = null;

			for (const intersect of intersects) {
				if (intersect.object.name === 'mud') {
					mudIntersect = intersect;
				} else if (intersect.object.name.indexOf('model') === 0) {
					modelIntersect = parseInt(intersect.object.name.split('-')[1]);
				}
			}

			targetOffset.current.x = mouse.x;
			targetOffset.current.y = mouse.y;

			if (typeof modelIntersect === 'number') {
				if (information[modelIntersect]?.title) {
					setActiveToolTip(information[modelIntersect].title);
				}
				hoveredItem.current = modelIntersect;
			} else if (mudIntersect) {
				currentOffset.current.lerp(targetOffset.current, 0.01);
				// hoveredItem.current = -1;
			}

			if (camera.current) {
				camera.current.position.x = currentOffset.current.x * 10;
				camera.current.position.z = -currentOffset.current.y * 5 + 5;
			}
		} else {
			hoveredItem.current = -1;
		}
	});

	useEffect(() => {
		setSceneIsLoaded(true);
	}, [setSceneIsLoaded]);

	return (
			<>
				<Camera camera={camera} />
				<Lights />
				<Beach currentOffset={currentOffset} targetOffset={targetOffset} />
				<Mud currentOffset={currentOffset} targetOffset={targetOffset} activeItemIndex={activeItemIndex} />
				<Models {...props} information={information} currentOffset={currentOffset} targetOffset={targetOffset} hoveredItem={hoveredItem} />
			</>
	)
}

const Scene = (props) => {

  return (
		<Canvas
			key={'information-scene'}
			gl={{
				antialias: true,
				toneMapping: THREE.ACESFilmicToneMapping,
			 }}
		>
			<Suspense fallback={null}>
				<SceneContent {...props} />
			</Suspense>
    </Canvas>
  )
}

export default Scene;
